import { useCareerCenterFetch } from "@/modules/careerCenter/hooks/useCareerCenterFetch"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"
import { useTracking } from "@/modules/tracking/useTracking"

type CompanyFollowTrackFunction = (follow: boolean) => void

export const useCompanyFollowTrack = (): CompanyFollowTrackFunction => {
  const tracking = useTracking()
  const { dataCompany } = useCompanyFetch()
  const { dataCareerCenter } = useCareerCenterFetch()

  return (follow: boolean) =>
    tracking?.track("company_page_follow_action", {
      action: follow ? "follow" : "unfollow",
      company_page_id: dataCompany?.id || "",
      context: "company_page",
      service: "company",
      ...(dataCareerCenter?.intranet && { school_id: dataCareerCenter?.id }),
    })
}
